(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ActuatorTypeEnum', actuatorTypeEnumFactory);

  /** @ngInject */
  function actuatorTypeEnumFactory () {
    return Object.freeze({
      SW: 'SW',
      RANGE: 'RANGE',
      properties: {
        SW: {
          parseValue: function (value) {
            return parseInt(value, 10) > 0 ? true : false;
          },
          parseRange: function (rangeValue) {
            return rangeValue;
          }
        },
        RANGE: {
          parseValue: function (value) {
            return parseFloat(value);
          },
          parseRange: function (rangeValue) {
            return rangeValue
          }
        }
      }
    });
  }
})();
